module.exports = __webpack_public_path__ + "dd6b7f735ed14558d07d4c35a7a3872c.svg";